/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersbusinessesempty2Inputs */

const en_partnersbusinessesempty2 = /** @type {(inputs: Partnersbusinessesempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No business has come through this partner yet.`)
};

const de_partnersbusinessesempty2 = /** @type {(inputs: Partnersbusinessesempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über diesen Partner ist noch kein Betrieb gekommen.`)
};

/**
* | output |
* | --- |
* | "No business has come through this partner yet." |
*
* @param {Partnersbusinessesempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersbusinessesempty2 = /** @type {((inputs?: Partnersbusinessesempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersbusinessesempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersbusinessesempty2(inputs)
	return de_partnersbusinessesempty2(inputs)
});
export { partnersbusinessesempty2 as "partnersBusinessesEmpty" }